const MODULE_NAME = 'UsersModule';

export const GET_CURRENT_USER = `${MODULE_NAME}/GET_CURRENT_USER`;
export const GET_ROLES = `${MODULE_NAME}/GET_ROLES`;
